export default __webpack_public_path__ + "static/media/bkg--interiors-2.bc2525a4.jpg";